<section>
    <div class="notification-detail">
        <h2>
            Notification
        </h2>
        <h3>
            {{notificationItem.title?.en}}
        </h3>
        <span class="notification-detail-date">{{notificationItem.createTime |  date:'dd/MM HH:mm'}}</span>
        <mat-divider></mat-divider>
        <p innerHTML="{{notificationItem.content?.en}}">
        </p>
    </div>
</section>
